exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.margin8-bottom[data-v-c2a07e78] {\n  margin-bottom: 0.4rem;\n}\n.padding0-5 > div[data-v-c2a07e78] {\n  border-radius: 0.4rem;\n  margin-bottom: 0.4rem;\n  overflow: hidden;\n}\n.isiphoneX[data-v-c2a07e78] {\n  padding-bottom: 1rem;\n}\n.certifications[data-v-c2a07e78] {\n  text-align: center;\n}\n.certifications a[data-v-c2a07e78] {\n  font-size: 0.6rem;\n  color: #00ab84;\n}", ""]);

// exports
